export enum FamilleLaverie {
  HOTEL = "HOTEL",
  BASE_MILITAIRE = "BASE_MILITAIRE",
  LOGEMENT_SOCIAL = "LOGEMENT_SOCIAL",
  RESIDENCE_JEUNES = "RESIDENCE_JEUNES",
  RESIDENCE_ETUDIANT = "RESIDENCE_ETUDIANT",
  RESIDENCE_DE_TOURISME = "RESIDENCE_DE_TOURISME",
  AUTRES = "AUTRES"
}

export enum ContratStatus {
  SIGNER = "SIGNER",
  PERDU = "PERDU",
  RESILIER = "RESILIER",
  EN_COURS = "EN_COURS"
}

export enum PeriodiciteStatus {
  MENSUELLE = "MENSUELLE",
  BIANNUELLE = "BIANNUELLE",
  BIMENSUELLE = "BIMENSUELLE",
  HEBDOMADAIRE = "HEBDOMADAIRE",
  TRIMESTRIELLE = "TRIMESTRIELLE"
}

export enum ProductStatus {
  NOUVEAU = "NOUVEAU",
  OCCASION = "OCCASION",
  EXPLOITATION = "EXPLOITATION",
  LIVRE = "LIVRE",
  VENDU = "VENDU"
}

export enum ProductType {
  LAVE_LINGE = "LAVE_LINGE",
  SECHE_LINGE = "SECHE_LINGE",
  STACKED_LAVE_LINGE = "STACKED_LAVE_LINGE",
  STACKED_SECHE_LINGE = "STACKED_SECHE_LINGE",
  CONDENSATEUR = "CONDENSATEUR",
  ARMOIRE_A_LESSIVE = "ARMOIRE_A_LESSIVE",
  PAYMENT_TERMINAL = "PAYMENT_TERMINAL",
  BALON_EAU_CHAUDE = "BALON_EAU_CHAUDE",
  POMPE_A_LESSIVE = "POMPE_A_LESSIVE",
  LINT_TRAP = "LINT_TRAP",
  MONNAYEUR = "MONNAYEUR",
  STAKED = "STAKED",
  ANTON = "ANTON",
  AIR_WALLET = "AIR_WALLET",
  NAYAX = "NAYAX",
  WI_WASH = "WI_WASH",
  WIMINI = "WIMINI"
}

export enum ProductMake {
  LG = "LG",
  PRIMUS = "PRIMUS",
  MAYTAG = "MAYTAG",
  ALLIANCE = "ALLIANCE",
  SPEED_QUEEN = "SPEED_QUEEN",
  IPSO = "IPSO",
  CENTER_MY_SERVICE = "CENTER_MY_SERVICE",
  WI_MINI = "WI_MINI",
  WI_LINE = "WI_LINE",
  WI_WASH = "WI_WASH",
  LM_CONTROL = "LM_CONTROL",
  MONEO = "MONEO",
  MS = "MS",
  AIRWALLET = "AIRWALLET",
  MY_LAUNDRY = "MY_LAUNDRY",
  IMSA = "IMSA",
  F1069FD4 = "F1069FD4",
}

export enum ReservationStatus {
  AVAILABLE = "AVAILABLE",
  RESERVED = "RESERVED",
  DETRUIT = "DETRUIT"
}

export enum TypeContrat {
  AOT = "AOT",
  VENTE = "VENTE",
  FLUIDE = "FLUIDE",
  RELEVE = "RELEVE",
  LOCATION = "LOCATION",
  EXPLOITATION = "EXPLOITATION"
}

export enum TaskType {
  PANNE = "PANNE",
  CAISSE_ET_MAINTENANCE = "CAISSE_ET_MAINTENANCE",
  RELEVE_FACTURATION = "RELEVE_FACTURATION",
  ENLEVEMENT = "ENLEVEMENT",
  LOCATION_MAINTENANCE = "LOCATION_MAINTENANCE",
  INSTALLATION = "INSTALLATION",
  PREPARATION = "PREPARATION"
}

export enum TaskStatus {
  A_FAIRE = "A_FAIRE",
  ASSIGNE = "ASSIGNE",
  EN_COURS = "EN_COURS",
  FAITE = "FAITE",
  NON_FAITE = "NON_FAITE",
  A_REPROGRAMMER = "A_REPROGRAMMER",
  APPROUVE = "APPROUVE"
}

export enum TaskListStatus {
  A_FAIRE = "A_FAIRE",
  ASSIGNE = "ASSIGNE",
  EN_COURS = "EN_COURS",
  FAITE = "FAITE",
  APPROUVE = "APPROUVE"
}

export enum MoyenDePaiement {
  CB = "CB",
  JETONS = "JETONS",
  MONNAIE = "MONNAIE",
  CB_MONNAIE = "CB_MONNAIE",
  MONNAIE_JETONS = "MONNAIE_JETONS",
  CB_IZLY = "CB_IZLY",
  GRATUIT = "GRATUIT",
  CB_MONNAIE_JETONS = "CB_MONNAIE_JETONS",
  CB_JETONS = "CB_JETONS"
}

export enum NotificationType {
  LAVERIE_ALERT = "LAVERIE_ALERT",
  PRODUCT_ALERT = "PRODUCT_ALERT",
  SPAREPART_ALERT = "SPAREPART_ALERT"
}

export enum SparepartType {
  LAVE_LINGE = "LAVE_LINGE",
  SECHE_LINGE = "SECHE_LINGE",
  STACKED_LAVE_LINGE = "STACKED_LAVE_LINGE",
  STACKED_SECHE_LINGE = "STACKED_SECHE_LINGE",
  CONDENSATEUR = "CONDENSATEUR",
  ARMOIRE_A_LESSIVE = "ARMOIRE_A_LESSIVE",
  PAYMENT_TERMINAL = "PAYMENT_TERMINAL",
  BALON_EAU_CHAUDE = "BALON_EAU_CHAUDE",
  KIT_EFFRACTION = "KIT_EFFRACTION"
}

export enum SparepartStatus {
  NOUVEAU = "NOUVEAU",
  OCCASION = "OCCASION"
}

export enum SparepartMake {
  LG = "LG",
  PRIMUS = "PRIMUS",
  MAYTAG = "MAYTAG",
  ALLIANCE = "ALLIANCE"
}

export enum AccountOrigin {
  EXTENSION_CLIENT = "EXTENSION_CLIENT",
  BOUCHE_A_OREILLE = "BOUCHE_A_OREILLE",
  SITE_INTERNET = "SITE_INTERNET",
  PROSPECTION = "PROSPECTION",
  APPEL_DOFFRE = "APPEL_DOFFRE",
  AUTRES = "AUTRES"
}

export enum PriseDeContactType {
  Mail = "Mail",
  Telephone = "Telephone",
  RDV = "RDV"
}

export enum JetonLLType {
  MS10 = "MS10",
  MS11 = "MS11"
}

export enum JetonSLType {
  MS35 = "MS35",
  MS55 = "MS55"
}

export enum Priority {
  URGENT = "URGENT",
  NORMAL = "NORMAL"
}

export enum VaultFileType {
  SIGNATURE = "SIGNATURE",
  PHOTO = "PHOTO",
  PDF = "PDF",
  REPORT = "REPORT",
  ATTACHMENT = "ATTACHMENT"
}

export enum RefEntityType {
  TASK = "TASK",
  PANNE = "PANNE",
  PRODUCT = "PRODUCT",
  LAVERIE = "LAVERIE"
}

export enum VaultFileTag {
  BEFORE = "BEFORE",
  AFTER = "AFTER"
}

export enum InterventionItemType { 
  CHECKBOX = "CHECKBOX", 
  TEXT = "TEXT", 
  NUMERIC = "NUMERIC" 
}
